// src/services/cacheService.js
class CacheService {
  constructor() {
    this.cache = new Map();
    this.version = '1.0.0';
    this.maxCacheSize = 100;
    this.defaultTTL = 10 * 60 * 1000;
  }

  set(key, data, ttl = this.defaultTTL) {
    if (this.cache.size >= this.maxCacheSize) {
      const oldestKey = this.cache.keys().next().value;
      this.cache.delete(oldestKey);
    }
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      ttl
    });
  }

  get(key) {
    const item = this.cache.get(key);
    if (!item) return null;
    const isExpired = Date.now() - item.timestamp > item.ttl;
    if (isExpired) {
      this.cache.delete(key);
      return null;
    }
    return item.data;
  }

  remove(key) {
    this.cache.delete(key);
  }

  clear() {
    this.cache.clear();
  }

  clearByPattern(pattern) {
    const keysToDelete = [];
    for (const key of this.cache.keys()) {
      if (key.includes(pattern)) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => this.cache.delete(key));
  }

  getStats() {
    return {
      size: this.cache.size,
      maxSize: this.maxCacheSize
    };
  }
}

export const cacheService = new CacheService();

export const CACHE_KEYS = {
  SITES: 'cached_sites',
  MAKES: 'cached_makes',
  TYRE_SIZES: 'cached_tyre_sizes',
  STATUS_CATEGORIES: 'cached_status_categories',
  POSITION_TYPES: 'cached_position_types',
  PROJECTS: 'cached_projects',
  USED_TYRE_TYPES: 'cached_used_tyre_types',
  WEAR_TYPES: 'cached_wear_types',
  TRUCK_MAKES: 'cached_truck_makes',
  TYRE_TYPES: 'cached_tyre_types',
  TYRE_ENTRIES: 'cached_tyre_entries', // ✅ Added this
};

export const invalidateCacheOnModification = (type) => {
  const patterns = {
    'tyre': ['cached_tyre_entries', 'cached_tyre_history', 'tyre_'],
    'project': ['cached_projects', 'cached_sites'],
    'user': ['cached_user_permissions', 'cached_user_data'],
    'master': ['cached_sites', 'cached_makes', 'cached_tyre_sizes', 'cached_status_categories', 'cached_position_types', 'cached_projects', 'cached_used_tyre_types', 'cached_wear_types', 'cached_truck_makes']
  };

  const patternToClear = patterns[type] || [type];
  patternToClear.forEach(pattern => {
    if (pattern.startsWith('cached_')) {
      cacheService.remove(pattern);
    } else {
      cacheService.clearByPattern(pattern);
    }
  });
};